import type {Values} from "@wix/devzai-utils-common";

export const BymoPageActionRoundness = {
    None: 0,
    Pixels8: 8,
    Pixels16: 16,
    Pixels25: 25
} as const;

export type BymoPageActionRoundness = Values<typeof BymoPageActionRoundness>;